// Unpublished Work © 2023 Deere & Company.
export const PENDING_DOWNLOADS_KEY = "pendingDownloads";
export const PENDING_JOBS_DOWNLOADS_KEY = "pendingJobsDownloads";
export const DOWNLOAD_JOB_COMPLETE = "DOWNLOAD_JOB_COMPLETE";
export const DOWNLOAD_NEW_JOB_COMPLETE = "DOWNLOAD_NEW_JOB_COMPLETE";
export const DOWNLOAD_JOB_ADDED = "DOWNLOAD_JOB_ADDED";
export const DOWNLOAD_NEW_JOB_ADDED = "DOWNLOAD_NEW_JOB_ADDED";
export const DOWNLOAD_ALL_ORDERS_JOB_COMPLETE =
  "DOWNLOAD_ALL_ORDERS_JOB_COMPLETE";
export const DOWNLOAD_ORDERS_BY_LINE_ITEM_JOB_COMPLETE =
  "DOWNLOAD_ORDERS_BY_LINE_ITEM_JOB_COMPLETE";
export const NOTIFY = "NOTIFY";
export const INV_DOWNLOAD_ID = "I";
export const INV_FILE_PREFIX = "INV";
